module.exports = __webpack_public_path__ + "media/images/front/common/icon_search-b89f40a847f4fe4330b9b0dbe5923587.svg";